import { OTHER_ID, payerLookUpNamesForAdministrationRoute, payerLookUpNamesForRequest, payerLookUpNamesForReqCare,
  baseUrl, PAYERMASTER_TYPE, ORION_PRODUCT_CODE_ARTEMIS, ORION_PRODUCT_CODE_FT, DIAGNOSIS_LOOK_UP_BY_VALUE_PAYERS } from './../../../shared/constants/crmConstants';
import {
  authFeatureConstants,
  PROD_AUTOMATION_SIMULATION,
  COMMON_ERROR,
} from './../../../shared/constants/commonConstants';
import { canActivate, createPayerLookUpReqPayload } from './../../../utils/utility';
import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  CONCATED_OTHER_TREATMENT_ICDS, lookUpNamesForReq, payerLookUpNamesForAllInsurer, payerLookUpNamesForGovt,
  payerLookUpNamesForReq,
  payerLookUpNamesForRPA,
  payerLookUpNamesForGrievanceType,
} from '../../../shared/constants/crmConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/lookUpType';
import { RootState } from '../..';
import { LookUpState, PayerLookUpState } from '../../models/lookUpModel';
import {
  setAllInsurers, setAllOnMailPayers, setLookUpValues, setPayerClaimStatuses, setPayerLookUpValues,
  setRIPayerClaimStatuses, updateRoleMaster, setAllGrievance, setDiagnosisValues, fetchDiagnosisLookup, setAllPayerClaimStatuses,
  fetchLookup, setAllGrievanceLookupAction,
  setGrievanceStatuses,
} from '../../actions/lookUpAction';
import { differenceBy, isEmpty, uniqBy } from 'lodash';
import { Payer } from '../../../shared/models/payer.model';
import { findKeyValuePair, getIcdCodeWithPrecedence, getLookUpFullDetail,
  getUniqePayerIds } from '../../../modules/crm/inPatient/service/crmUtils';
import { ApplicationDetailModel } from '../../models/applicationDetailModel';
import { centeredNotification } from '../../../utils/utility';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import { setClaimMandatoryClassifications } from '../../actions/claimDetailsAction';
import _ from 'lodash';
import { setReconciliationClaimStatuses } from '../../actions/reconciliationAction';
import { setProbability } from '../../actions/newAdmissionAction';
import { encryptText } from '../../../utils/encryptDecrypt';
import { FilteredStatus, PayerClaimStatus } from '../../../shared/interfaces/grievanceInterface';
import { PayerInitialState } from '../../models/payerListModel';
import { setHISTreatmentValuesFromLookUp } from '../../actions/hospitalAction';
import { HISTreatmentIDs } from '../../../shared/interfaces/newAdmissionInterface';
import { NewAdmissionState } from '../../models/newAdmissionModel';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../src/config/formControlConfig';

const payerLookUpUrl = GLOBAL_URL.CRM_BASE_URL + 'Master/PayerLookUp';

function uiMigration(masterArray: any[] = [], valueString: string, nameString: string): any[] {
  const arr = masterArray
    .filter((master: any): any => master[nameString] && master[valueString])
    .map((master: any): any => {
      return {
        ...master, ...{
          label: master[nameString].toString(),
          name: master[nameString].toString(),
          value: master[valueString].toString(),
        },
      };
    });
  return uniqBy(arr, 'value');
}
function uiMigrationHDFC(masterArray: any[] = [], valueString: string, nameString: string): any[] {
  const arr = masterArray
    .filter((master: any): any => master[nameString] && master[valueString])
    .map((master: any): any => {
      return {
        ...master, ...{
          label: master[valueString].toString(),
          name: master[nameString].toString(),
          value: master[nameString].toString(),
        },
      };
    });
  return uniqBy(arr, 'value');
}

const getProductCodeValue = (newAdmission: any, claimDetail: any, payerName: string,
  isGovtScheme: boolean, productCode: string): string[] | undefined => {
  const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();
  const payerConfigValues = Object.values(CONTROL_CONFIG_BASED_ON_PAYER[payerName] || {});
  const isArtemisPayer = (payerConfigValues)?.some((config: any): any => config?.type === ORION_PRODUCT_CODE_ARTEMIS);
  if (isOrionIntegrationEnabledProvider && isArtemisPayer) {
    return [(newAdmission?.isArtemis || claimDetail?.isArtemisClaim) ? ORION_PRODUCT_CODE_ARTEMIS : ORION_PRODUCT_CODE_FT];
  }
  return isGovtScheme ? [productCode] : undefined;
};

const getPayerLookUpMasterType = (...lookUpMasterArgs: any[]): string[] => {
  // Handle the case where only masterIds is passed
  if (lookUpMasterArgs.length === 1) {
    const masterIds = lookUpMasterArgs[0] as HISTreatmentIDs;
    const masterTypes: string[] = [];
    if (!isEmpty(masterIds.diagnosisIds)) {
      masterTypes.push(PAYERMASTER_TYPE.DIAGNOSIS);
    }
    if (!isEmpty(masterIds.procedureIds)) {
      masterTypes.push(PAYERMASTER_TYPE.PROCEDURE);
    }

    return masterTypes;
  }
  const [shortName, isGovtScheme, isRpaPayer] = lookUpMasterArgs;

  let payerLookupReq: string[] = DIAGNOSIS_LOOK_UP_BY_VALUE_PAYERS.includes(shortName) ?
  payerLookUpNamesForRequest : (shortName === 'CARE') ? payerLookUpNamesForReqCare : payerLookUpNamesForReq;
  if (isGovtScheme) {
    payerLookupReq = [...payerLookupReq, ...payerLookUpNamesForGovt];
  } else if (isRpaPayer) {
    payerLookupReq = [...payerLookupReq, ...payerLookUpNamesForRPA];
  }
  if (shortName === 'FHPL' || shortName === 'GODIGIT') {
    payerLookupReq = [...payerLookupReq, ...payerLookUpNamesForAdministrationRoute];
  }
  return payerLookupReq;
};

function* createXhrArray(
  payerId: number, uniqueId: string, isGovtScheme: boolean, productCode: string,
  isOnMailPayer: boolean, isCorporate: boolean, isRpaPayer: boolean, shortName: string, payerName: string,
): Generator {
  const sendRequest = SendRequest.instance;
  const appService = ApplicationDetail.instance;

  const { diagnosisType, pastHistory, proposedLineOfTreatment,
    courierService }: any = yield select((state: RootState): LookUpState => state.lookUp);
  const payerLookUpState: any = yield select((state: RootState): PayerLookUpState => state.payerLookUp);
  const applicationDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const { hospitalProfile }: any = yield select((state: RootState): any => state.hospital);
  const hospitalProfileId = hospitalProfile?.length === 1 ? hospitalProfile[0].id : '';
  const newAdmission: any = yield select((state: RootState): NewAdmissionState => state.newAdmission);
  const claimDetail: any = yield select((state: RootState): RootState => state.admissionDetails) as any;

  const lookUpUrl = GLOBAL_URL.CRM_BASE_URL + 'Master/LookUp';
  const doctorListURL = GLOBAL_URL.REACT_APP_INVENTORY_API_BASE_URL + 'Inventory/FetchDoctors';

  const lookUpReq = { getByName: true, names: lookUpNamesForReq, isDicFormat: true };
  const payerLookUpMasterTypes: string[] = getPayerLookUpMasterType(shortName, isGovtScheme, isRpaPayer);

  const productCodeValue = getProductCodeValue(newAdmission, claimDetail, payerName, isGovtScheme, productCode);
  const payerLookUpReqObj = createPayerLookUpReqPayload([payerId], productCodeValue, payerLookUpMasterTypes, appService);

  const profileIds =
    canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS) && hospitalProfileId
      ? [hospitalProfileId] : [applicationDetail.getProfileId()];

  const inventoryReqObj = {
    pageSize: 300,
    doctorByProfileId: true,
    fetchInActiveRecord: true,
    profileIds,
  };

  const xhrFor: { [x: string]: boolean } = {};
  const xhrArray = [];
  if (!diagnosisType?.length && !pastHistory?.length && !proposedLineOfTreatment?.length && !courierService?.length) {
    xhrArray.push(yield sendRequest.post(lookUpUrl, lookUpReq));
    xhrFor.lookUp = true;
  }

  if (
    !payerLookUpState[uniqueId] ||
    canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)
  ) {
    if (isCorporate) {
      xhrArray.push(null);
      xhrArray.push(null);
      xhrArray.push(null);
    } else {
      xhrArray.push(yield sendRequest.post(payerLookUpUrl, payerLookUpReqObj));
      xhrArray.push(yield sendRequest.post(doctorListURL, inventoryReqObj));
    }
    xhrFor.payerLookUp = true;
  }
  return { xhrFor, xhrArray };
}

export function* fetchLookUps({ payload: { lookUpSuccessCallback, uniquePayerId } }: any): Generator {
  let selectedPayer: any;
  const payerList: any = yield select((state: RootState): Payer[] => state.payerList.allPayers);
  if (uniquePayerId) {
    selectedPayer = payerList.find(({ uniqueIdentifier }: Payer): boolean => uniqueIdentifier === uniquePayerId);
  } else {
    selectedPayer = yield select((state: RootState): Payer => state.payerList.payer);
  }
  let uniqueId: any; let isGovtScheme: boolean; let productCode: string; let payerId: number; let isOnMailPayer: boolean;
  let isCorporate: boolean; let isRpaPayer: boolean; let shortName: string; let payerName: string;
  const { mandatoryClassification } = selectedPayer || {};
  if (selectedPayer) {
    const { uniqueIdentifier, isGovtScheme: isGovt, productCode: pCode, id, isOnMailPayer: onMailPayer, isCorporatePayer
      , isRpaPayer: isRpa, shortName: shortN, name } = selectedPayer;
    uniqueId = uniqueIdentifier;
    isGovtScheme = isGovt;
    payerId = id;
    productCode = pCode;
    isOnMailPayer = onMailPayer;
    isCorporate = isCorporatePayer;
    isRpaPayer = isRpa;
    shortName = shortN;
    payerName = name;
  } else {
    lookUpSuccessCallback(false);
    return;
  }

  // const payerLookUp = localStorage.getItem('payerLookUp');
  // const lookUp = localStorage.getItem('lookUp');
  // if (lookUp) {
  //   yield put(setLookUpValues(JSON.parse(lookUp)));
  // }

  // if (payerLookUp && !canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
  //   const parsedPayerLookUp = JSON.parse(payerLookUp);
  //   if (parsedPayerLookUp[uniqueId]) {
  //     yield put(setPayerLookUpValues(parsedPayerLookUp));
  //     lookUpSuccessCallback(false);
  //     return;
  //   }
  // }

  const {
    xhrFor, xhrArray,
  }: any = yield createXhrArray(
    payerId, uniqueId, isGovtScheme,
    productCode, isOnMailPayer,
    isCorporate, isRpaPayer, shortName, payerName,
  );

  if (!xhrArray?.length && lookUpSuccessCallback) {
    lookUpSuccessCallback(false);
    return;
  }

  try {
    const response: any = yield Promise.all(xhrArray);
    if (response?.length) {
      let lookUpResponse; let payerLookUpResponse; let doctorsList;
      if (xhrFor.lookUp && xhrFor.payerLookUp) {
        [lookUpResponse, payerLookUpResponse, doctorsList] = response;
      } else if (xhrFor.lookUp) {
        [lookUpResponse] = response;
      } else if (xhrFor.payerLookUp) {
        [payerLookUpResponse, doctorsList] = response;
      }
      if (lookUpResponse) {
        yield setLookUp(lookUpResponse);
      }
      if (payerLookUpResponse || mandatoryClassification || doctorsList) {
        yield setPayerLookUp(payerLookUpResponse, uniqueId, mandatoryClassification, doctorsList);
      }
      if (lookUpSuccessCallback) {
        lookUpSuccessCallback(false);
      }
    }
  } catch (err) { }
}

function* setLookUp(lookUpResponse: any): Generator {
  const { isSuccess } = lookUpResponse;
  if (isSuccess) {
    const {
      masterLookUpsNew: {
        Past_History,
        Proposed_line_of_Treatment,
        Diagnosis_Type,
        Designations,
        relation,
        bad_treatment = [],
        bad_diagnosis = [],
        courier_service = [],
      },
    } = lookUpResponse;

    const lookUp: LookUpState = {
      pastHistory: uiMigration(Past_History, 'id', 'value'),
      proposedLineOfTreatment: uiMigration(Proposed_line_of_Treatment, 'id', 'value'),
      diagnosisType: uiMigration(Diagnosis_Type, 'id', 'value'),
      designation: uiMigration(Designations, 'id', 'value'),
      relation: uiMigration(relation, 'id', 'value'),
      badTreatment: bad_treatment.map(({ value }: any): string => value && value.toLowerCase()),
      badDiagnosis: bad_diagnosis.map(({ value }: any): string => value && value.toLowerCase()),
      courierService: courier_service.map(({ value, id, name }: any): any => ({ value, id, name })),
    };
    localStorage.setItem('lookUp', JSON.stringify(lookUp));
    yield put(setLookUpValues(lookUp));
  }
}

function* setPayerLookUp(payerlookUpResponse: any, uniqueId: string,
  mandatoryClassificationResponse: any, doctorDetails: any): Generator {
  const appService = ApplicationDetail.instance;
  const { isSuccess } = payerlookUpResponse || {};
  let payerLookUp: PayerLookUpState = {};
  if (isSuccess) {
    const {
      masterDetailsNew: {
        Diagnosis, Procedure, document_type, room_type, insurer_name,
        District, Designations, relation, unit, AdministrationRoute, GrievanceType, speciality, admission_type, corporate_name,
        Proposed_line_of_Treatment, past_history, Doctor_Qualification, State_Medical_Council, Package_charges, Room_rent_Nursing_charges,
        Investigation_charges,
        ICU_Charges,
        Consultation_charges,
        OT_charges,
        Surgeon_anesthetist,
        Medicine_consumables,
        Professional_Fees,
        High_Risk_Charges,
        Ambulance_Charges,
        Blood_Charges,
        Cathlab_Charges,
        Diabetic_Charges,
        Medical_Equipment,
        Food_Beverages, Implants_charges,
        Doctor_Specialization,
        Reason_For_Cancellation,
      },
      automationProcedures = [],
    } = payerlookUpResponse;

    if (PROD_AUTOMATION_SIMULATION?.HOSPITALS?.includes(Number(appService.getProviderId()))) {
      automationProcedures.push(
        {
          'id': 1,
          'procedure': 'Cataract',
          'icdCode': [
            'H25.012',
            'H25.011',
          ],
          'diagnosis': [],
          'mandatoryDocument': [],
          'questions': [],
          'proposedLineOfTreatmentID': 1123,
          'maMappedProcedure': 'Cataract',
        },
      );
    }
    payerLookUp = {
      [uniqueId]: {
        ...payerLookUp[uniqueId],
        diagnosis: uiMigration(Diagnosis, 'masterLookId', 'payerMasterValue'),
        speciality: uiMigration(speciality, 'payerMasterValue', 'payerMasterValue'),
        admission_type: uiMigration(admission_type, 'payerMasterValue', 'payerMasterValue'),
        procedure: uiMigration(Procedure, 'payerMasterValue', 'payerMasterValue'),
        documentType: uiMigration(document_type, 'masterLookId', 'payerMasterValue'),
        roomType: uiMigration(room_type, 'masterLookId', 'payerMasterValue'),
        GrievanceType: uiMigration(GrievanceType, 'masterLookId', 'payerMasterValue'),
        insurerName: uiMigration(insurer_name, 'masterLookId', 'payerMasterValue'),
        district: uiMigration(District, 'masterLookId', 'payerMasterValue'),
        designation: uiMigration(Designations, 'masterLookId', 'payerMasterValue'),
        relation: uiMigration(relation, 'masterLookId', 'payerMasterValue'),
        unitName: uiMigration(unit, 'masterLookId', 'payerMasterValue'),
        corporate_name: uiMigration(corporate_name, 'masterLookId', 'payerMasterValue'),
        doctorSpecialization: uiMigration(Doctor_Specialization, 'masterLookId', 'payerMasterValue'),
        automationProcedures: uiMigration(automationProcedures, 'id', 'procedure'),
        administrationRoute: uiMigration(AdministrationRoute, 'masterLookId', 'payerMasterValue'),
        proposedLineOfTreatment: uiMigration(Proposed_line_of_Treatment, 'masterLookId', 'payerMasterValue'),
        pastHistory: uiMigration(past_history, 'masterLookId', 'payerMasterValue'),
        doctorQualification: uiMigration(Doctor_Qualification, 'masterLookId', 'payerMasterValue'),
        stateMedicalCouncil: uiMigration(State_Medical_Council, 'masterLookId', 'payerMasterValue'),
        Package_charges: uiMigration(Package_charges, 'masterLookId', 'payerMasterValue'),
        Room_rent_Nursing_charges: uiMigration(Room_rent_Nursing_charges, 'masterLookId', 'payerMasterValue'),
        Investigation_charges: uiMigration(Investigation_charges, 'masterLookId', 'payerMasterValue'),
        ICU_Charges: uiMigration(ICU_Charges, 'masterLookId', 'payerMasterValue'),
        Consultation_charges: uiMigration(Consultation_charges, 'masterLookId', 'payerMasterValue'),
        OT_charges: uiMigration(OT_charges, 'masterLookId', 'payerMasterValue'),
        Surgeon_anesthetist: uiMigration(Surgeon_anesthetist, 'masterLookId', 'payerMasterValue'),
        Medicine_consumables: uiMigration(Medicine_consumables, 'masterLookId', 'payerMasterValue'),
        Professional_Fees: uiMigration(Professional_Fees, 'masterLookId', 'payerMasterValue'),
        High_Risk_Charges: uiMigration(High_Risk_Charges, 'masterLookId', 'payerMasterValue'),
        Ambulance_Charges: uiMigration(Ambulance_Charges, 'masterLookId', 'payerMasterValue'),
        Blood_Charges: uiMigration(Blood_Charges, 'masterLookId', 'payerMasterValue'),
        Cathlab_Charges: uiMigration(Cathlab_Charges, 'masterLookId', 'payerMasterValue'),
        Diabetic_Charges: uiMigration(Diabetic_Charges, 'masterLookId', 'payerMasterValue'),
        Medical_Equipment: uiMigration(Medical_Equipment, 'masterLookId', 'payerMasterValue'),
        Food_Beverages: uiMigration(Food_Beverages, 'masterLookId', 'payerMasterValue'),
        Implants_charges: uiMigration(Implants_charges, 'masterLookId', 'payerMasterValue'),
        reasonForCancellation: uiMigration(Reason_For_Cancellation, 'payerMasterValue', 'payerMasterValue'),
      },
    };
  }
  const diagnosisMasterLookup = {};
  try {
    payerLookUp[uniqueId]?.diagnosis.map((ele: any): any => {
      ele['value'] = ele['payerMasterValue'];
      ele['label'] = ele['masterLookId'];
      const parentId = `${ele?.payerParentId}`;
      if (parentId !== '0') {
        if (diagnosisMasterLookup[parentId]) {
          diagnosisMasterLookup[parentId]?.push(ele);
        } else {
          diagnosisMasterLookup[parentId] = [ele];
        }
      }
    });
    yield put(setDiagnosisValues(diagnosisMasterLookup));
  } catch (e) {
    yield put(setDiagnosisValues({}));
    console.error(e);
  }
  if (mandatoryClassificationResponse) {
    payerLookUp = {
      [uniqueId]: {
        ...payerLookUp[uniqueId],
        mandatoryClassificationName: mandatoryClassificationResponse || [],
      },
    };
  }

  const { isSuccess: isSuccessDoctorResponse } = doctorDetails || {};
  if (isSuccessDoctorResponse) {
    let { doctorDetails: doctorList } = doctorDetails || {};
    doctorList = doctorList?.filter(({ id, personalDetail, isActive }: any): boolean =>
      id && personalDetail?.name && isActive)
      .map(({ id, personalDetail, professionalDetail, isActive }: any): any => {
        return {
          value: id,
          name: personalDetail.name,
          registrationNo: professionalDetail?.registrationNumber || undefined,
          signature: professionalDetail?.doctorSignature || undefined,
          isActive,
        };
      });

    payerLookUp = {
      [uniqueId]: {
        ...payerLookUp[uniqueId],
        doctorList,
      },
    };
  }
  yield put(setPayerLookUpValues(payerLookUp));
  // yield localStorage.setItem('payerLookUp', JSON.stringify(payerLookUp)); // ! LocalStorage overflow
  yield fetchProviderInsurer({ payload: uniqueId });
}

export function* fetchPackageList({ payload: { searchKey, onSuccess, onError, searchWithRoomType } }: any): any {
  const fetchPackageUrl = GLOBAL_URL.CRM_BASE_URL + 'Provider/Search/Package';
  const appDetailService = ApplicationDetail.instance;
  const { id: payerId, isGovtScheme, productCode, shortName } = yield select((state: RootState): Payer => state.payerList.payer);
  const { diagnosisDynamicLookup }: any = yield select((state: RootState): LookUpState => state.lookUp);
  const {
    admissionFormVal: {
      treatmentDetail: { payerRoomType, roomTypeOthers, hospitalRoomType, diagnosisMandatory, diagnosis = [], maternityType,
        automatedProcedure },
      customerDetail: { insurerName = '', memberId, policyNumber },
    },
    selectedPackage = [],
  } = yield select((state: RootState): any => state.newAdmission);

  let icdCode = [];
  let roomTypeCategory;
  const uniqIdentifier = yield select((state: RootState): any => state?.payerList?.payer?.uniqueIdentifier);
  const selectedPayerDetail = yield select((state: RootState): any => state?.payerLookUp[uniqIdentifier] || {});
  const selectedRoomType = payerRoomType || roomTypeOthers;
  const selectedRoom = selectedPayerDetail?.roomType?.find(({ masterLookId }: any): any => masterLookId === parseInt(selectedRoomType, 10));
  const selectedProviderRoom = selectedPayerDetail?.providerRoomType?.find(({ value }: any): boolean => value === hospitalRoomType);
  const { payerMasterId: insurerIdByVal } = findKeyValuePair(selectedPayerDetail?.insurerName, 'value', insurerName, true) || {};
  const { formControlConfig }: any = yield select((state: RootState): PayerInitialState => state.payerList);
  const payerConfigValues = Object.values(formControlConfig);
  const isStarIPPPayer = payerConfigValues?.some((config: any): boolean => Boolean(config?.showProductName));
  const { icd10 }: any =
    yield select((state: RootState): any => state.admissionDetails.claimDetails);
  const { payerMasterId: insurerIdByLabel } =
    findKeyValuePair(selectedPayerDetail?.insurerName, 'payerMasterValue', insurerName, true) || {};

  if (selectedRoom) {
    roomTypeCategory = [selectedRoom?.payerMasterValue];
  } else if (selectedProviderRoom) {
    roomTypeCategory = ((shortName === 'HDFC' && process.env.REACT_APP_IS_ROOM_CATEGORY_ALLOWED === 'true') || isStarIPPPayer)
    ? [selectedProviderRoom?.providerRoomType] : [selectedProviderRoom?.roomCategory];
  }

  if (automatedProcedure && automatedProcedure !== OTHER_ID) {
    const [selectedAutomatedProcedure] = getLookUpFullDetail([automatedProcedure], selectedPayerDetail?.automationProcedures, false) || [];
    icdCode = selectedAutomatedProcedure?.icdCode;
  } else {
    const selectedDiagnosis = getLookUpFullDetail([diagnosisMandatory].concat(diagnosis),
      (shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true')
        ? diagnosisDynamicLookup : selectedPayerDetail?.diagnosis, true);
    icdCode = selectedDiagnosis?.map(({ payerMasterId }: any): string => payerMasterId);
  }
  const selectedIcdCode = (icdCode || []).find((id: string): boolean =>
    CONCATED_OTHER_TREATMENT_ICDS.includes(id));

  const finalIcdCode = selectedIcdCode ? String(selectedIcdCode).split('.')[0] : undefined;

  const requestObject = {
    icdCode: (shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true' && automatedProcedure === OTHER_ID)
      ? (icdCode[1]?.split('.')[0] !== undefined ? String(icdCode[1]?.split('.')[0]) : icd10)
      : isStarIPPPayer ? icdCode?.[0]?.toString() : getIcdCodeWithPrecedence(finalIcdCode, maternityType),
    payerId: payerId?.toString(),
    packageFilterKey: searchKey ? searchKey : undefined,
    productCode: isGovtScheme ? productCode : undefined,
    roomType: ((searchWithRoomType || !appDetailService.getIsNewAutomationEnabled() ||
    (shortName === 'HDFC' && process.env.REACT_APP_IS_ROOM_CATEGORY_ALLOWED === 'true')) || isStarIPPPayer) ?
    roomTypeCategory : undefined, // adding roomType for fetching packages in case of HDFC (IPP-4798)
    insurerId: insurerIdByVal || insurerIdByLabel,
  };

  const sendRequest = SendRequest.instance;
  try {
    const response = yield sendRequest.post(fetchPackageUrl, requestObject);
    const { errors } = response;
    let { mappedpackages, isSuccess } = response;
    if (PROD_AUTOMATION_SIMULATION?.HOSPITALS?.includes(Number(appDetailService.getProviderId())) && payerId === 516571 &&
      (
        memberId === PROD_AUTOMATION_SIMULATION?.MEMBER_ID ||
        policyNumber === PROD_AUTOMATION_SIMULATION?.POLICY_NO
      )) {
      mappedpackages = [
        {
          'package_Name': 'Cataract removal',
          'packageId': 873434,
          'perP_PER_ID': 0,
          'general_Ward': 27500,
          'private_Ward': 27500,
          'semi_Private_Ward': 27500,
          'deluxe_Other': 0,
          'discount': 0,
          'peR_PackageAlias': 'Cataract',
          'packageType': null,
          'package_Start_date': '0001-01-01T00:00:00',
          'package_Expiry_date': '0001-01-01T00:00:00',
          'isPendingForApproval': false,
          'distinctPrices': null,
          'packageTagName': null,
          'icD_Name': 'H25',
          'packageCost': 27500,
          'is_Per_Day_Eligible_Package': null,
          'value': '165485842345919',
          'name': 'Cataract removal - 27,500',
        },
        {
          'package_Name': 'Cataract removal',
          'packageId': 873435,
          'perP_PER_ID': 0,
          'general_Ward': 28000,
          'private_Ward': 28000,
          'semi_Private_Ward': 28000,
          'deluxe_Other': 0,
          'discount': 0,
          'peR_PackageAlias': 'Cataract',
          'packageType': null,
          'package_Start_date': '0001-01-01T00:00:00',
          'package_Expiry_date': '0001-01-01T00:00:00',
          'isPendingForApproval': false,
          'distinctPrices': null,
          'packageTagName': null,
          'icD_Name': 'H25',
          'packageCost': 28000,
          'is_Per_Day_Eligible_Package': null,
          'value': '165485842345920',
          'name': 'Cataract removal - 28,000',
        },
      ];
      isSuccess = true;
    }
    if (isSuccess) {
      const filteredPackages = differenceBy(mappedpackages, selectedPackage, 'packageId');
      const timestamp = new Date().getTime();
      const updateMappedPackages = filteredPackages
        .map((mPackage: any, index: number): any => {
          const { package_Name: name } = mPackage;
          return {
            ...mPackage, value: String(timestamp + index), name,
          };
        });

      onSuccess(selectedPackage.concat(updateMappedPackages));
    } else {
      onError(errors);
    }
  } catch (e) {
    onError(e);
  }
}

export function* fetchInpatientStatus(): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Master/ClaimStatus`;
  const sendRequest = SendRequest.instance;
  const { isPreAuthView }: any = yield select((state: RootState): any => state.selectedInPatientDetail);
  const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);

  try {
    const { isSuccess, errors, payerClaimStatuses = [] }: any = yield sendRequest.post(url, {});
    if (isSuccess) {
      yield localStorage.setItem(
        'payerClaimStatuses',
        encryptText(JSON.stringify(payerClaimStatuses)),
      );
      const filteredStatus =
        payerClaimStatuses
          .filter(({ isActive }: any): boolean => isActive)
          .filter(({ claimType }: any): any => claimType === 'CASHLESS')
          .map(({ statusId, providerDisplayStatus }: any): any => ({ key: String(statusId), value: providerDisplayStatus }));

      const filteredStatusReimbursement =
        payerClaimStatuses
          .filter(({ isActive }: any): boolean => isActive)
          .filter(({ claimType }: any): any => claimType === 'REIMBURSEMENT')
          .map(({ statusId, providerDisplayStatus }: any): any => ({ key: String(statusId), value: providerDisplayStatus }));

      const filteredStatusReconciliation =
        payerClaimStatuses
          .filter(({ isActive }: any): boolean => isActive)
          .filter(({ claimType }: any): any => claimType === 'RECONCILIATION')
          .map(({ statusId, providerDisplayStatus }: any): any => ({ key: String(statusId), value: providerDisplayStatus }));

      const filteredStatusPreAuthView = payerClaimStatuses
        ?.filter(({ isActive }: any): boolean => isActive)
        ?.filter(({ viewTypes }: any): any => {
          if (!viewTypes) {
            return false;
          }
          return viewTypes.includes('PreAuthView');
        })
        ?.map(({ statusId, providerDisplayStatus }: any): any => ({
          key: String(statusId),
          value: providerDisplayStatus,
        }));

      const filteredGrievanceStatus = payerClaimStatuses
        .filter((status: PayerClaimStatus): boolean => status.isActive)
        .filter((status: PayerClaimStatus): boolean => status.claimType === 'GRIEVANCE')
        .map((status: PayerClaimStatus): FilteredStatus => ({
          key: String(status.statusId),
          value: status.providerDisplayStatus,
        }));

      const filteredStatusClaimView = payerClaimStatuses
        ?.filter(({ isActive }: any): boolean => isActive)
        ?.filter(({ viewTypes }: any): any => {
          if (!viewTypes) {
            return false;
          }
          return viewTypes?.includes('ClaimView');
        })
        ?.map(({ statusId, providerDisplayStatus }: any): any => ({
          key: String(statusId),
          value: providerDisplayStatus,
        }));
      yield localStorage.setItem(
        'filteredStatusPreAuthView',
        encryptText(JSON.stringify(filteredStatusPreAuthView)),
      );
      yield localStorage.setItem(
        'filteredStatusClaimView',
        encryptText(JSON.stringify(filteredStatusClaimView)),
      );
      yield localStorage.setItem(
        'grievanceStatus',
        encryptText(JSON.stringify(filteredGrievanceStatus)));
      yield localStorage.setItem(
        'filteredStatus',
        encryptText(JSON.stringify(filteredStatus)),
      );
      yield localStorage.setItem(
        'filteredStatusReimbursement',
        encryptText(JSON.stringify(filteredStatusReimbursement)),
      );
      yield put(setReconciliationClaimStatuses(filteredStatusReconciliation));
      yield put(setPayerClaimStatuses(appDetail?.getIsPreAuthClaimViewEnabled() ? isPreAuthView ?
        filteredStatusPreAuthView : filteredStatusClaimView : filteredStatus));
      yield put(setAllPayerClaimStatuses(filteredStatus));
      yield put(setRIPayerClaimStatuses(filteredStatusReimbursement));
      yield put(setGrievanceStatuses(filteredGrievanceStatus));
    } else {
      centeredNotification(errors.join('\n'));
    }
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

export function* fetchAllInsurers(): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const allPayers: any = yield select((state: RootState): any => state?.payerList?.allPayers || []);
    const payerLookUpReqObj = createPayerLookUpReqPayload(getUniqePayerIds(allPayers), undefined, payerLookUpNamesForAllInsurer);
    const { isSuccess, masterDetailsNew }: any = yield sendRequest.post(payerLookUpUrl, payerLookUpReqObj) || {};
    const { insurer_name = [] } = masterDetailsNew || {};
    let allInsurerName: any = [];
    if (isSuccess && insurer_name.length > 0) {
      allInsurerName = insurer_name.map(({ payerMasterValue }: any): any => ({ key: payerMasterValue, value: payerMasterValue }));
      yield put(setAllInsurers(_.uniqBy(allInsurerName, (ele: any): any => ele?.value)));
    } else {
      yield put(setAllInsurers([]));
    }
  } catch (e) {
    yield put(setAllInsurers([]));
    console.error(e);
  }
}

export function* fetchLookupGrievanceMaster(): Generator {
  const lookUp: any = yield select((state: RootState): any => state?.lookUp || {});

  if (!(lookUp?.grievanceLookup?.length)) {
    const lookUpReq = { getByName: true, names: payerLookUpNamesForGrievanceType, isDicFormat: true };
    const fetchUrl = `${GLOBAL_URL.CRM_BASE_URL}Master/LookUp`;
    const sendRequest = SendRequest.instance;
    try {
      const lookUpResponse: any = yield sendRequest.post(fetchUrl, lookUpReq);
      const { masterLookUpsNew } = lookUpResponse || {};
      const { Grievance_Reason = [] } = masterLookUpsNew || {};
      yield put(setAllGrievanceLookupAction(Grievance_Reason));
    } catch (e) {
      centeredNotification(COMMON_ERROR);
    }
  }
}

export function* fetchAllGrievanceType({ payload: { payerLookUpReqObj } }: any): Generator {
  const sendRequest = SendRequest.instance;
  const lookUp: any = yield select((state: RootState): any => state?.lookUp || {});
  if (!(lookUp?.allGrievances?.length)) {
    try {
      const { isSuccess, masterDetailsNew }: any = yield sendRequest.post(payerLookUpUrl, payerLookUpReqObj) || {};
      const { Grievance_Reason = [] } = masterDetailsNew || {};
      if (isSuccess && Grievance_Reason.length > 0) {
        const grievanceOptions = Grievance_Reason?.map((ele: any): any => ({
          ...ele,
          value: ele.payerMasterId,
          label: ele.payerMasterValue,
        }));
        yield put(setAllGrievance(grievanceOptions));
      } else {
        yield put(setAllGrievance([]));
      }
    } catch (e) {
      yield put(setAllGrievance([]));
      console.error(e);
    }
  }
}

function* fetchAllOnMailPayers({ payload: { onSuccess, onFailure } }: any): any {
  const payerListLookupUrl = baseUrl + 'Provider/Search/PayerListLookUp';
  const { onMailPayers = [] }: any = select((state: RootState): LookUpState => state.lookUp);
  const isVersioningPostAPIEnabled = ApplicationDetail?.instance?.getIsVersioningPostAPIEnabled(); // Checking the flag

  try {
    if (!(onMailPayers?.length > 0)) {
      const sendRequest = SendRequest.instance;
      let response: any;
      if (isVersioningPostAPIEnabled) {
        response = yield sendRequest.post(payerListLookupUrl, {});
      } else {
        response = yield sendRequest.get(payerListLookupUrl);
      }
      const { isSuccess, payers }: any = response;
      if (isSuccess) {
        yield put(setAllOnMailPayers(
          payers.map(({ payerName: label, payerID: value }: any): any => ({ label, value })),
        ));
        onSuccess();
      } else {
        onFailure();
      }
    } else {
      onSuccess();
    }
  } catch (e) {
    onFailure();
  }
}

function* fetchProviderRoomTypes({ payload: { onSuccess, insurerId, dateOfAdmission } }: any): Generator {
  const providerRoomTypeUrl = GLOBAL_URL.CRM_BASE_URL + 'Provider/Search/HospitalSpecificRoomTypes';
  const sendReq = SendRequest.instance;
  const { id: payerId, productCode, uniqueIdentifier, isOnMailPayer, name }: any =
    yield select((state: RootState): Payer => state?.payerList?.payer || {});
  const completePayerLookUp: any = yield select((state: RootState): any => state?.payerLookUp || {});
  const payerConfigValues = Object.values(CONTROL_CONFIG_BASED_ON_PAYER[name] || {});
  const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();
  const isArtemisPayer = (payerConfigValues)?.some((config: any): any => config?.type === 'ARTEMIS');
  const isOrionIntegrationEnabledPayerProvider = isOrionIntegrationEnabledProvider && isArtemisPayer;
  const { isArtemisClaim}: any = yield select((state: RootState): any => state.admissionDetails);
  const { isArtemis}: any = yield select((state: RootState): any => state.newAdmission);

  const isArtemisFlow = isArtemis || isArtemisClaim;
  const providerRoomTypeReqObj = {
    payerId,
    productCode : (isOrionIntegrationEnabledPayerProvider && isArtemisFlow) ? ORION_PRODUCT_CODE_ARTEMIS :
    productCode,
    insurerId,
    doa: dateOfAdmission,
  };
  try {
    if (!isOnMailPayer) {
      const { isSuccess, roomTypeDetails }: any = yield sendReq.post(providerRoomTypeUrl, providerRoomTypeReqObj) || {};
      let payerLookUp: PayerLookUpState = {};
      if (isSuccess) {
        const filteredRoomTypeDetails = roomTypeDetails.filter(({ providerRoomType }: any): boolean => providerRoomType);
        payerLookUp = {
          ...completePayerLookUp,
          [uniqueIdentifier]: {
            ...completePayerLookUp[uniqueIdentifier],
            providerRoomType: uiMigration(filteredRoomTypeDetails, 'providerRoomType', 'providerRoomType'),
          },
        };
        yield put(setPayerLookUpValues(payerLookUp));
      }
      onSuccess(payerLookUp, providerRoomTypeReqObj);
    } else {
      onSuccess(null, providerRoomTypeReqObj);
    }
  } catch (e) {
    onSuccess();
  }
}

function* fetchRoleMasterSaga(): Generator {
  const fetchUrl = `${baseUrl}Master/ModuleRoleLookup`;
  const sendRequest = SendRequest.instance;
  const isVersioningPostAPIEnabled = ApplicationDetail?.instance?.getIsVersioningPostAPIEnabled();
  try {
    const { roleMaster = [] }: any = yield select((state: RootState): LookUpState => state.lookUp);
    let response: any;
    if (!roleMaster?.length) {
      if (isVersioningPostAPIEnabled) {
        response = yield sendRequest.post(fetchUrl, {});
      } else {
        response = yield sendRequest.get(fetchUrl);
      }
      const { isSuccess, moduleRoleLookUp }: any = response;
      if (isSuccess) {
        yield put(updateRoleMaster(moduleRoleLookUp));
      } else {
        yield put(updateRoleMaster([]));
      }
    }
  } catch (e) {
    yield put(updateRoleMaster([]));
  }
}

function* fetchMandatoryClassificationWithCurrStage({ payload: { currentStatus, payerId, productCode, onSuccess } }: any): Generator {
  yield put(setClaimMandatoryClassifications({}));
  const mandatoryClassificationUrl = GLOBAL_URL.CRM_BASE_URL + 'Provider/Search/ClaimStatusRule';
  try {
    if (currentStatus) {
      const requestPayload = {
        payerId,
        productCode,
        statusName: currentStatus,
      };
      const sendReq = SendRequest.instance;
      const { isSuccess, allowStatus = [] }: any = yield sendReq.post(mandatoryClassificationUrl, requestPayload);
      if (isSuccess) {
        const docTypesObj = {};
        allowStatus.map(({ actionName, documentName }: any): any => {
          docTypesObj[actionName] = documentName;
          return docTypesObj;
        });
        yield put(setClaimMandatoryClassifications(docTypesObj));
      }
      onSuccess();
    }
    onSuccess();
  } catch (e) {
    yield put(setClaimMandatoryClassifications({}));
    onSuccess();
  }
}

function* fetchOtherMandatoryClassificationWithCurrStage({ payload }: any): Generator {
  yield put(setClaimMandatoryClassifications({}));
  const { uniqueIdentifier }: any =
    yield select((state: RootState): Payer => state?.payerList?.payer || {});
  const completePayerLookUp: any = yield select((state: RootState): any => state?.payerLookUp || {});
  const mandatoryClassificationUrl = GLOBAL_URL.CRM_BASE_URL + 'Provider/Search/GetOtherMandatoryClassification';
  let payerLookUp: PayerLookUpState = {};
  try {
    const requestPayload = {
      payerId: payload?.payerID,
      claimStage: payload?.claimStage,
      procedure: payload?.treatment,
      icdCode: payload?.icd,
      insurerName: payload?.insurerName,
    };
    const sendReq = SendRequest.instance;
    const { isSuccess, documentName, probabilityofQuery = [] }:
      any = yield sendReq.post(mandatoryClassificationUrl, requestPayload);
    if (isSuccess) {
      payerLookUp = {
        ...completePayerLookUp,
        [uniqueIdentifier]: {
          ...completePayerLookUp[uniqueIdentifier],
          otherMandatoryClassification: documentName || [],
        },
      };
      yield put(setPayerLookUpValues(payerLookUp));
      yield put(setProbability(probabilityofQuery));
    } else {
      if (payerLookUp?.otherMandatoryClassification) {
        payerLookUp = {
          ...completePayerLookUp,
          [uniqueIdentifier]: {
            ...completePayerLookUp[uniqueIdentifier],
            otherMandatoryClassification: [],
          },
        };
        yield put(setPayerLookUpValues(payerLookUp));
      }
      yield put(setProbability(0));
    }
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

export function* fetchProviderInsurer({ payload: uniqPayerId }: any): Generator {
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/HospitalSpecificInsurance`;
    const sendRequest = SendRequest.instance;
    let payerToFetch: Payer;
    const { payer, allPayers }: any = yield select((state: RootState): any => state?.payerList || {});
    const completePayerLookUp: any = yield select((state: RootState): any => state?.payerLookUp || {});
    // localStorage.setItem('payerLookUp', JSON.stringify(completePayerLookUp));

    if (!(completePayerLookUp[uniqPayerId || payer?.uniqueIdentifier]?.providerSpecificInsurers?.length)) {
      if (uniqPayerId) {
        payerToFetch = allPayers?.find(({ uniqueIdentifier }: Payer): boolean => uniqueIdentifier === uniqPayerId);
      } else {
        payerToFetch = payer;
      }

      if (payerToFetch) {
        const reqObject = { payerId: payerToFetch.id, productCode: payerToFetch.productCode };
        const { isSuccess, insurances }: any = yield sendRequest.post(url, reqObject);
        let payerLookUp: PayerLookUpState = {};
        if (isSuccess) {
          payerLookUp = {
            ...completePayerLookUp,
            [uniqPayerId]: {
              ...completePayerLookUp[uniqPayerId],
              providerSpecificInsurers: uiMigration((insurances || []), 'inusrerId', 'inusrerName'),
              isHospSpecificInsurerPayerResponse: isSuccess,
            },
          };
          yield put(setPayerLookUpValues(payerLookUp));
          // return localStorage.setItem('payerLookUp', JSON.stringify(payerLookUp));
        }
      }
    }
  } catch (e) {
    console.error(e);
  }
}

function* fetchLookupMasterSaga(): Generator {
  const lookUp: any = yield select((state: RootState): any => state?.lookUp || {});

  if (!(lookUp?.courierService?.length)) {
    const lookUpReq = { getByName: true, names: lookUpNamesForReq, isDicFormat: true };
    const fetchUrl = `${GLOBAL_URL.CRM_BASE_URL}Master/LookUp`;
    const sendRequest = SendRequest.instance;
    try {
      const lookUpResponse: any = yield sendRequest.post(fetchUrl, lookUpReq);
      yield setLookUp(lookUpResponse);
    } catch (e) {
      centeredNotification(COMMON_ERROR);
    }
  }
}
function* otherTreatmentSynonym({ payload }: any): Generator {
  const { treatmentSelected, treatmentSelectedTreatment } = payload;
  try {
    const { id: payerId, productCode, isGovtScheme }: any = yield select((state: RootState): Payer => state?.payerList?.payer || {});
    const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
    const { treatmentValue, diagnosisValue }: any = yield select((state: RootState): LookUpState => state.lookUp);
    const reqPayload = {
      getByProductCode: isGovtScheme ? true : false,
      providerId: appDetail.getProviderId(),
      payerId,
      productCode,
      DiagnosisSynonym: diagnosisValue?.toString() || '',
      TreatmentSynonym: treatmentValue?.toString() || '',
    };
    const url = `${GLOBAL_URL.CRM_BASE_URL}Master/SynonymLookup`;
    const response: any = yield SendRequest.instance.post(url, reqPayload);
    treatmentSelected ? treatmentSelected(response) : treatmentSelectedTreatment(response);
  } catch (e) {
    treatmentSelected ?
      treatmentSelected({ isSuccess: false, errors: [COMMON_ERROR] }) :
      treatmentSelectedTreatment(({ isSuccess: false, errors: [COMMON_ERROR] }));
  }
}
function* setDynamicLookUpDiagnosis({ payload }: any): Generator {
  try {
    const { id: payerId }: any = yield select((state: RootState): Payer => state?.payerList?.payer || {});
    const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
    const reqPayload = {
      getByMasterType: true,
      providerId: appDetail.getProviderId(),
      payerId,
      masterType: 'Diagnosis',
      masterValue: payload?.toString() || '',
    };
    const url = `${GLOBAL_URL.CRM_BASE_URL}Master/PayerLookUpByValue`;
    const response: any = yield SendRequest.instance.post(url, reqPayload);
    if (response) {
      yield put(fetchDiagnosisLookup(uiMigrationHDFC(response?.masterDetailsNew?.Diagnosis, 'masterLookId', 'payerMasterValue')));
    } else {
      yield put(fetchDiagnosisLookup([]));
    }
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* setDynamicLookUp({ payload }: any): Generator {
  try {
    const { id: payerId }: any = yield select((state: RootState): Payer => state?.payerList?.payer || {});
    const appDetail: any = yield select((state: RootState): ApplicationDetailModel => state.applicationDetail);
    const reqPayload = {
      getByMasterType: true,
      providerId: appDetail.getProviderId(),
      payerId,
      masterType: payload?.masterType?.toString() || '',
      masterValue: payload?.searchText?.toString() || '',
    };
    const url = `${GLOBAL_URL.CRM_BASE_URL}Master/PayerLookUpByValue`;
    const response: any = yield SendRequest.instance.post(url, reqPayload);
    if (response) {
      yield put(fetchLookup(uiMigrationHDFC
        (response?.masterDetailsNew?.[payload?.masterType?.toString()], 'masterLookId', 'payerMasterValue'), payload?.masterType));
    } else {
      yield put(fetchLookup([], payload?.masterType));
    }
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

export function* getHISTreatmentLookUpValues(
  { payload }: { type: string, payload: any }): Generator {
  const { masterIds, onLookUpSuccess, onLookUpFailure } = payload || {};
  const sendRequest = SendRequest.instance;
  const newAdmission = yield select((state: RootState): NewAdmissionState => state.newAdmission);
  const claimDetail = yield select((state: RootState): RootState => state.admissionDetails);
  const selectedPayer: any = yield select((state: RootState): Payer => state.payerList.payer);
  const { id: payerId, isGovtScheme, productCode, name: payerName } = selectedPayer || {};
  const { diagnosisIds = [], procedureIds = [] } = masterIds || {};
  const masterIdsArray = [...diagnosisIds, ...procedureIds];
  try {
    const productCodeValue = getProductCodeValue(newAdmission, claimDetail, payerName, isGovtScheme, productCode);
    const payerLookUpMasterTypes: string[] = getPayerLookUpMasterType(masterIds);
    const payerLookUpReqObj = createPayerLookUpReqPayload([payerId], productCodeValue, payerLookUpMasterTypes, undefined, masterIdsArray);
    const { isSuccess, masterDetailsNew }: any = yield sendRequest.post(payerLookUpUrl, payerLookUpReqObj) || {};
    if (isSuccess && masterDetailsNew) {
      onLookUpSuccess(masterDetailsNew);
    } else {
      yield put(setHISTreatmentValuesFromLookUp([]));
      onLookUpFailure();
    }
  } catch (e) {
    yield put(setHISTreatmentValuesFromLookUp([]));
    onLookUpFailure();
  }
}

export function* watchLookUp(): any {
  yield takeEvery(actionTypes.FETCH_LOOK_UP_VALUES, fetchLookUps);
  yield takeEvery(actionTypes.FETCH_MANDATORY_CLASSIFICATIONS, fetchMandatoryClassificationWithCurrStage);
  yield takeEvery(actionTypes.FETCH_OTHER_MANDATORY_CLASSIFICATIONS, fetchOtherMandatoryClassificationWithCurrStage);
  yield takeEvery(actionTypes.FETCH_PACKAGE, fetchPackageList);
  yield takeLatest(actionTypes.FETCH_INPATIENT_STATUSES, fetchInpatientStatus);
  yield takeLatest(actionTypes.FETCH_ALL_INSURERS, fetchAllInsurers);
  yield takeLatest(actionTypes.FETCH_ALL_ONMAIL_PAYERS, fetchAllOnMailPayers);
  yield takeLatest(actionTypes.FETCH_PROVIDER_ROOM_TYPES, fetchProviderRoomTypes);
  yield takeLatest(actionTypes.FETCH_GRIEVANCE_TYPES, fetchAllGrievanceType);
  yield takeLatest(actionTypes.FETCH_GRIEVANCE_LOOK_UP, fetchLookupGrievanceMaster);
  yield takeLatest(actionTypes.FETCH_ROLE_MASTER, fetchRoleMasterSaga);
  yield takeLatest(actionTypes.FETCH_LOOKUP_MASTER, fetchLookupMasterSaga);
  yield takeEvery(actionTypes.OTHER_TREATMENT_SELECTED, otherTreatmentSynonym);
  yield takeEvery(actionTypes.SET_DYNAMIC_DIAGNOSIS_VALUES, setDynamicLookUpDiagnosis);
  yield takeEvery(actionTypes.SET_DYNAMIC_LOOKUP_VALUES, setDynamicLookUp);
  yield takeEvery(actionTypes.GET_HIS_TREATMENT_LOOKUP_VALUES, getHISTreatmentLookUpValues);
}

export default watchLookUp;
